/* 
    *  You have to include the store in each modal because  
    *  ionic decided they didn't need to access it. This 
    *  also won't show up in your Vue Debugger.
*/

import './styles.scss';
import store from '../../store/';

export default {
    name: 'AddFixtureModal',

    store,

    data() {
        return {
            location: '',
            description: '',
            type: ''
        }
    },

    computed: {
        types() {
            return this.$store.getters.getFixtureTypes;
        },

        canSubmit() {
            return !!this.location && !!this.type;
        }
    },

    methods: {
        dismissModal() {
            this.$ionic.modalController.dismiss();
        },

        createFixture() {
            if (this.$store.state.online_status) {
                const ctx = {
                    location: this.location,
                    description: this.description, 
                    type: this.type,
                    subscription: this.$store.state.subscriptions.active_subscription.id
                };

                this.$store.dispatch('createFixtureDB', ctx).then((response) => {
                    this.$ionic.modalController.dismiss();
                }).catch((error) => {
                    this.$ionic.alertController.create({
                        message: 'Unable to create fixture.',
                        buttons:['OK']
                    }).then(a => a.present());
                });
            } else {
                this.$ionic.alertController.create({
                    message: 'Please establish and internet connection and try again.',
                    buttons:['OK']
                }).then(a => a.present());
            }
        }
    }
};